package diana.soleil.design.iraniancanadienbazzar.navigation

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import diana.soleil.design.iraniancanadienbazzar.core.common.AppError
import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import diana.soleil.design.iraniancanadienbazzar.core.data.ConnectivityController
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.MockDataController
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBanner
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomNavBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomNavItem
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppFab
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PlatformStatusBarAppearance
import androidx.compose.material3.Text
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTopNavBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BrandMark
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FeatureTourOverlay
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.rememberTourState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.tourAnchor
import kotlinx.coroutines.delay
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.NotificationBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.WindowWidthClass
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.windowWidthClassFor
import diana.soleil.design.iraniancanadienbazzar.auth.AuthViewModel
import diana.soleil.design.iraniancanadienbazzar.core.common.AppBuildInfo
import diana.soleil.design.iraniancanadienbazzar.core.common.DataResult
import diana.soleil.design.iraniancanadienbazzar.core.data.FeatureFlags
import diana.soleil.design.iraniancanadienbazzar.core.data.NotificationRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.SunsetConfig
import kotlinx.coroutines.flow.map
import androidx.compose.foundation.layout.size
import org.koin.compose.viewmodel.koinViewModel
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.DashboardViewModel
import diana.soleil.design.iraniancanadienbazzar.feature.feed.FeedDeepLinks
import diana.soleil.design.iraniancanadienbazzar.feature.feed.FeedRoute
import diana.soleil.design.iraniancanadienbazzar.feature.home.HomeRoute
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.MarketplaceIntents
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.MarketplaceRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.InboxRoute
import diana.soleil.design.iraniancanadienbazzar.feature.profile.ProfileScreen
import diana.soleil.design.iraniancanadienbazzar.locale.AppearanceController
import diana.soleil.design.iraniancanadienbazzar.locale.LocaleController
import org.koin.compose.koinInject
import iraniancanadienbazzar.shared.generated.resources.Res
import iraniancanadienbazzar.shared.generated.resources.app_name
import iraniancanadienbazzar.shared.generated.resources.nav_messages
import iraniancanadienbazzar.shared.generated.resources.mock_data_banner
import iraniancanadienbazzar.shared.generated.resources.prod_preview_banner
import iraniancanadienbazzar.shared.generated.resources.nav_notifications
import iraniancanadienbazzar.shared.generated.resources.nav_notifications_unread_a11y
import iraniancanadienbazzar.shared.generated.resources.nav_feed
import iraniancanadienbazzar.shared.generated.resources.nav_home
import iraniancanadienbazzar.shared.generated.resources.nav_market
import iraniancanadienbazzar.shared.generated.resources.nav_profile
import iraniancanadienbazzar.shared.generated.resources.nav_post
import iraniancanadienbazzar.shared.generated.resources.tour_home_title
import iraniancanadienbazzar.shared.generated.resources.tour_home_body
import iraniancanadienbazzar.shared.generated.resources.tour_feed_title
import iraniancanadienbazzar.shared.generated.resources.tour_feed_body
import iraniancanadienbazzar.shared.generated.resources.tour_market_title
import iraniancanadienbazzar.shared.generated.resources.tour_market_body
import iraniancanadienbazzar.shared.generated.resources.tour_messages_title
import iraniancanadienbazzar.shared.generated.resources.tour_messages_body
import iraniancanadienbazzar.shared.generated.resources.tour_post_title
import iraniancanadienbazzar.shared.generated.resources.tour_post_body
import iraniancanadienbazzar.shared.generated.resources.tour_profile_title
import iraniancanadienbazzar.shared.generated.resources.tour_profile_body
import iraniancanadienbazzar.shared.generated.resources.tour_next
import iraniancanadienbazzar.shared.generated.resources.tour_done
import iraniancanadienbazzar.shared.generated.resources.tour_skip
import iraniancanadienbazzar.shared.generated.resources.owner_welcome_title
import iraniancanadienbazzar.shared.generated.resources.owner_welcome_body
import iraniancanadienbazzar.shared.generated.resources.owner_welcome_tour
import iraniancanadienbazzar.shared.generated.resources.owner_welcome_later
import iraniancanadienbazzar.shared.generated.resources.post_guest_title
import iraniancanadienbazzar.shared.generated.resources.post_guest_message
import iraniancanadienbazzar.shared.generated.resources.post_guest_cta
import iraniancanadienbazzar.shared.generated.resources.post_sheet_title
import iraniancanadienbazzar.shared.generated.resources.post_action_ask
import iraniancanadienbazzar.shared.generated.resources.post_action_business
import iraniancanadienbazzar.shared.generated.resources.post_action_feed
import iraniancanadienbazzar.shared.generated.resources.post_action_market
import iraniancanadienbazzar.shared.generated.resources.placeholder_desc
import iraniancanadienbazzar.shared.generated.resources.placeholder_title
import iraniancanadienbazzar.shared.generated.resources.delete_account_cancel
import iraniancanadienbazzar.shared.generated.resources.delete_account_confirm
import iraniancanadienbazzar.shared.generated.resources.delete_account_failed
import iraniancanadienbazzar.shared.generated.resources.delete_account_password_label
import iraniancanadienbazzar.shared.generated.resources.delete_account_title
import iraniancanadienbazzar.shared.generated.resources.delete_account_warning
import iraniancanadienbazzar.shared.generated.resources.delete_account_wrong_password
import iraniancanadienbazzar.shared.generated.resources.offline_banner
import iraniancanadienbazzar.shared.generated.resources.sunset_banner_default
import iraniancanadienbazzar.shared.generated.resources.sunset_dismiss_a11y
import org.jetbrains.compose.resources.stringResource

/** Bottom-nav tabs (Stitch: Home · Feed · Market · Events · Profile). */
private object Tabs {
    const val HOME = "home"
    const val FEED = "feed"
    const val MARKET = "market"
    const val MESSAGES = "messages"
    const val PROFILE = "profile"
}

/** Feature-tour anchor key for the create/Post action (FAB on narrow, top-bar button on wide). */
private const val TOUR_KEY_POST = "post"

/** Delay before the first-run tour opens, so the first frame (and anchor bounds) settle. */
private const val FEATURE_TOUR_SETTLE_MS = 600L

/**
 * Main app shell: persistent bottom navigation. The full tab set is Home · Feed · Market · Messages ·
 * Profile, but **Feed/Market/Messages only appear once their `feature_*_enabled` Remote Config flag is
 * on** — store builds never show an unfinished surface, and flipping a flag "launches" the tab for
 * everyone without a store release (see `docs/ROADMAP.md`). If the active tab's flag turns off (e.g.
 * emergency kill-switch), selection falls back to Home.
 *
 * Messages replaced Events in the 4th slot on 2026-08-02: Messages is the retention surface (DMs,
 * requests, business channels, the welcome DM) and was previously reachable only via a top-bar icon,
 * while Events — still the acquisition wedge — is better served by a Home entry card plus deep links
 * straight to `Route.EventDetail` than by a tab nobody browses.
 */
@Composable
fun MainScaffold(
    onOpenCategories: () -> Unit = {},
    onOpenCategory: (categoryId: String) -> Unit = {},
    onOpenSearch: () -> Unit = {},
    onOpenMap: () -> Unit = {},
    onOpenBusiness: (businessId: String) -> Unit = {},
    onOpenNews: (articleId: String) -> Unit = {},
    onOpenNewsList: () -> Unit = {},
    onOpenGems: () -> Unit = {},
    onOpenAdmin: () -> Unit = {},
    onOpenEvents: () -> Unit = {},
    onOpenSettings: () -> Unit = {},
    onOpenSaved: () -> Unit,
    onOpenConversation: (conversationId: String) -> Unit = {},
    onNewMessage: () -> Unit = {},
    onOpenChannel: (businessId: String) -> Unit = {},
    onOpenPeople: () -> Unit = {},
    onOpenPeopleMap: () -> Unit = {},
    onOpenPerson: (uid: String) -> Unit = {},
    onOpenDashboard: () -> Unit = {},
    onOpenOrders: () -> Unit = {},
    onGetFreeTickets: (eventId: String) -> Unit = {},
    onOpenEventDetail: (eventId: String) -> Unit = {},
    onOpenTickets: () -> Unit = {},
    onOpenMarketplaceItem: (itemId: String) -> Unit = {},
    onOpenNotifications: () -> Unit = {},
    onAddBusiness: () -> Unit = {},
    onOpenBlockedUsers: () -> Unit = {},
    onOpenTerms: () -> Unit = {},
    onRequireSignIn: () -> Unit = {},
    onSignOut: () -> Unit = {},
    onAccountDeleted: () -> Unit = {},
    authViewModel: AuthViewModel = koinViewModel(),
) {
    val features by koinInject<FeatureFlags>().available.collectAsState()
    val buildInfo = koinInject<AppBuildInfo>()
    // One-time spotlight feature tour over the main controls (competitive parity with guided-tour
    // onboarding; docs/MARKETING.md § Competitive landscape). Anchors ride the nav items/FAB;
    // steps for flag-hidden tabs skip themselves.
    val preferences = koinInject<AppPreferences>()
    val tour = rememberTourState()
    val items = buildList {
        add(AppBottomNavItem(stringResource(Res.string.nav_home), "explore", Tabs.HOME, Modifier.tourAnchor(tour, Tabs.HOME)))
        if (features.feed) add(AppBottomNavItem(stringResource(Res.string.nav_feed), "dynamic_feed", Tabs.FEED, Modifier.tourAnchor(tour, Tabs.FEED)))
        if (features.marketplace) add(AppBottomNavItem(stringResource(Res.string.nav_market), "storefront", Tabs.MARKET, Modifier.tourAnchor(tour, Tabs.MARKET)))
        // Messages took the slot Events used to hold (2026-08-02). Messages is the retention surface
        // — DMs, message requests, business channels, the welcome DM — and burying it behind a
        // top-bar icon leaked re-engagement. Events keeps a first-class Home entry card + its own
        // route, and shared links still deep-link straight to the event.
        if (features.chat) add(AppBottomNavItem(stringResource(Res.string.nav_messages), "chat_bubble", Tabs.MESSAGES, Modifier.tourAnchor(tour, Tabs.MESSAGES)))
        add(AppBottomNavItem(stringResource(Res.string.nav_profile), "person", Tabs.PROFILE, Modifier.tourAnchor(tour, Tabs.PROFILE)))
    }
    // The tour runs only when asked (Settings → App tour, Developer Menu) — never on first run.
    // Short settle delay so the first frame (and anchor bounds) land first.
    LaunchedEffect(Unit) {
        if (preferences.featureTourRequested) {
            preferences.featureTourRequested = false
            delay(FEATURE_TOUR_SETTLE_MS)
            tour.start()
        }
    }
    // rememberSaveable, NOT remember (owner bug 2026-09-20): pushing any route on top of Route.Main
    // (Profile → Settings/Saved, Home → a business, …) takes this composable OUT of composition, so a
    // plain `remember` dropped the tab and Back popped you onto Home instead of the tab you left.
    // Users read that as "the back button doesn't work". The back-stack entry keeps its saveable
    // state while a destination sits on top, so this restores the tab on pop — and survives
    // rotation/process death for free. Tabs are plain Strings, so no custom Saver is needed.
    var selected by rememberSaveable { mutableStateOf(Tabs.HOME) }
    if (items.none { it.route == selected }) selected = Tabs.HOME
    // Raised center "Post" button (Gooya-style, owner direction 2026-07-11): one prominent create
    // entry point on every tab. Opens a sheet of the create actions available under current flags.
    var showCreateSheet by remember { mutableStateOf(false) }
    // QA 2026-09-12: a guest used to get the full create sheet, fill in a form, and only then be
    // bounced to the main screen with their work gone. Tell them up front instead.
    val createSession by authViewModel.session.collectAsState()
    val createIsGuest = createSession == null || createSession?.isAnonymous == true

    // A tapped comment notification routes here; switch to the Feed tab so FeedRoute can open the
    // post's comments sheet (it consumes the pending post id itself).
    val pendingComments by FeedDeepLinks.pendingCommentsPostId.collectAsState()
    LaunchedEffect(pendingComments) {
        if (pendingComments != null && items.any { it.route == Tabs.FEED }) selected = Tabs.FEED
    }
    // "Ask the mahaleh" (create sheet or search's empty state): land on Feed; the composer opens
    // itself in Question mode and consumes the flag.
    val pendingAsk by FeedDeepLinks.pendingAsk.collectAsState()
    LaunchedEffect(pendingAsk) {
        if (pendingAsk && items.any { it.route == Tabs.FEED }) selected = Tabs.FEED
    }

    BoxWithConstraints {
        // Desktop/web (Expanded) gets a top nav bar (Stitch "…(Desktop)"); narrow keeps the bottom bar.
        val wide = windowWidthClassFor(maxWidth) == WindowWidthClass.Expanded
        val brand = stringResource(Res.string.app_name)
        val notificationsLabel = stringResource(Res.string.nav_notifications)

        Scaffold(
            containerColor = AppTheme.colors.background,
            // Home paints its brand band BEHIND the status bar; every other tab re-adds the
            // inset itself below. Without this the scaffold reserves a white strip up top.
            contentWindowInsets = WindowInsets(0, 0, 0, 0),
            topBar = {
                if (wide) {
                    // Unread count for the desktop bell — narrow layouts surface it on the Home
                    // header bell instead (the header bell hides itself on Expanded to avoid the
                    // double-bell the web shipped with).
                    val notificationRepository = koinInject<NotificationRepository>()
                    val unreadNotifications by remember(notificationRepository) {
                        notificationRepository.observeNotifications()
                            .map { result -> (result as? DataResult.Success)?.data?.count { !it.read } ?: 0 }
                    }.collectAsState(0)
                    AppTopNavBar(
                        brand = brand,
                        brandMark = {
                            // Decorative — the wordmark text beside it carries the name for a11y.
                            BrandMark(
                                contentDescription = null,
                                modifier = Modifier.size(AppTheme.sizes.topNavBrandMark),
                            )
                        },
                        items = items,
                        selectedRoute = selected,
                        onSelect = { selected = it.route },
                        trailing = {
                            AppIconButton(
                                iconName = "add_circle",
                                contentDescription = stringResource(Res.string.nav_post),
                                onClick = { showCreateSheet = true },
                                tint = AppTheme.colors.onPrimary,
                                modifier = Modifier.tourAnchor(tour, TOUR_KEY_POST),
                            )
                            Box(contentAlignment = Alignment.TopEnd) {
                                AppIconButton(
                                    iconName = "notifications",
                                    contentDescription = notificationsLabel,
                                    onClick = onOpenNotifications,
                                    tint = AppTheme.colors.onPrimary,
                                )
                                NotificationBadge(
                                    count = unreadNotifications,
                                    contentDescription = stringResource(
                                        Res.string.nav_notifications_unread_a11y,
                                        unreadNotifications,
                                    ),
                                )
                            }
                        },
                    )
                }
            },
            bottomBar = {
                if (!wide) {
                    // Plain 5-tab bar; the "Post" create action is a floating button now
                    // (owner direction 2026-07-13), not a raised center nav slot.
                    AppBottomNavBar(
                        items = items,
                        selectedRoute = selected,
                        onSelect = { selected = it.route },
                    )
                }
            },
            floatingActionButton = {
                // Narrow layout only — the desktop top bar carries its own add action.
                if (!wide) {
                    AppFab(
                        iconName = "add",
                        contentDescription = stringResource(Res.string.nav_post),
                        onClick = { showCreateSheet = true },
                        modifier = Modifier.tourAnchor(tour, TOUR_KEY_POST),
                    )
                }
            },
        ) { innerPadding ->
        Column(modifier = Modifier.padding(innerPadding)) {
        // Status banners (prod-preview/mock/sunset/offline) are hoisted to the app shell
        // (AppStatusBanners in App.kt) so pushed routes show them too.
        val contentModifier = Modifier.weight(1f)
        // Home and Messages own their status-bar zone — both paint a brand-coloured header that
        // must run edge-to-edge behind the status bar (Home's band; the inbox's primaryContainer
        // header, which applies its own statusBarsPadding). Adding the inset here as well pushed
        // the inbox header down and left an unpainted background strip above it, so the status bar
        // visibly failed to match the header. Both also need LIGHT status-bar icons: their headers
        // are dark, and dark-on-dark icons are unreadable. Every other tab keeps the classic inset
        // and dark icons over the plain background.
        val ownsStatusBar = selected == Tabs.HOME || selected == Tabs.MESSAGES
        // Home already flips its own icons on scroll (StatusBarScrim) — calling it here too would
        // fight that. Messages has a permanently dark header, so it wants light icons outright.
        if (selected != Tabs.HOME) PlatformStatusBarAppearance(lightIcons = selected == Tabs.MESSAGES)
        val insetModifier =
            if (ownsStatusBar) contentModifier else contentModifier.statusBarsPadding()
        when (selected) {
            Tabs.HOME -> {
                val homeLocale = koinInject<LocaleController>()
                val homeLanguage by homeLocale.language.collectAsState()
                HomeRoute(
                modifier = contentModifier,
                onSearch = onOpenSearch,
                onOpenMap = onOpenMap,
                onNotifications = onOpenNotifications,
                currentLanguage = homeLanguage,
                onSelectLanguage = homeLocale::setLanguage,
                // Messages is a tab now — the Home header icon switches to it rather than pushing a
                // second copy of the inbox onto the stack.
                onOpenMessages = if (features.chat) ({ selected = Tabs.MESSAGES }) else null,
                onOpenPeople = onOpenPeople,
                onOpenPeopleMap = onOpenPeopleMap,
                onOpenPerson = onOpenPerson,
                onSeeAllCategories = onOpenCategories,
                onCategoryClick = onOpenCategory,
                onBusinessClick = onOpenBusiness,
                onNewsClick = onOpenNews,
                onSeeAllNews = onOpenNewsList,
                onOpenGems = onOpenGems,
                onOpenEvents = onOpenEvents,
                onOpenEventDetail = onOpenEventDetail,
            )
            }
            Tabs.FEED -> FeedRoute(
                modifier = insetModifier,
                onRequireSignIn = onRequireSignIn,
                onOpenBusiness = onOpenBusiness,
                onOpenEvent = onOpenEventDetail,
            )
            Tabs.MARKET -> MarketplaceRoute(
                modifier = insetModifier,
                onItemClick = onOpenMarketplaceItem,
                onRequireSignIn = onRequireSignIn,
                onOpenBusiness = onOpenBusiness,
            )
            Tabs.MESSAGES -> InboxRoute(
                modifier = insetModifier,
                // A tab is the root of its own stack — there is nothing to pop back to, so Back
                // returns to Home rather than leaving the shell.
                onBack = { selected = Tabs.HOME },
                onOpenConversation = onOpenConversation,
                onNewMessage = onNewMessage,
                onOpenPeople = onOpenPeople,
                onRequireSignIn = onRequireSignIn,
                onOpenChannel = onOpenChannel,
            )
            Tabs.PROFILE -> {
                val locale = koinInject<LocaleController>()
                val language by locale.language.collectAsState()
                val appearance = koinInject<AppearanceController>()
                val appearanceMode by appearance.mode.collectAsState()
                val isAdmin by authViewModel.isAdmin.collectAsState()
                val canModerate by authViewModel.canModerate.collectAsState()
                val session by authViewModel.session.collectAsState()
                val dashboardViewModel = koinViewModel<DashboardViewModel>()
                val ownerState by dashboardViewModel.state.collectAsState()
                ProfileScreen(
                    modifier = insetModifier,
                    userName = session?.displayName,
                    userEmail = session?.email,
                    isGuest = session == null || session?.isAnonymous == true,
                    onBusinessClick = onOpenBusiness,
                    dashboardEnabled = ownerState.businesses.isNotEmpty(),
                    onOpenDashboard = onOpenDashboard,
                    ordersEnabled = features.ordering,
                    onOpenOrders = onOpenOrders,
                    ticketsEnabled = features.events,
                    onOpenTickets = onOpenTickets,
                    // Every preference now lives on the pushed Settings screen.
                    onOpenSettings = onOpenSettings,
                    onOpenSaved = onOpenSaved,
                )

                // Store-required account deletion (Apple 5.1.1(v) / Play User Data): confirm +
                // password reauth for email accounts, then AuthService wipes data server-side.
            }
            else -> EmptyState(
                modifier = insetModifier,
                title = stringResource(Res.string.placeholder_title),
                description = stringResource(Res.string.placeholder_desc),
            )
        }
        }
        }

        if (showCreateSheet && createIsGuest) {
            AppBottomSheet(
                onDismissRequest = { showCreateSheet = false },
                title = stringResource(Res.string.post_guest_title),
            ) {
                Text(
                    text = stringResource(Res.string.post_guest_message),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                AppButton(
                    text = stringResource(Res.string.post_guest_cta),
                    onClick = {
                        showCreateSheet = false
                        onRequireSignIn()
                    },
                    leadingIcon = "login",
                    modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.lg),
                )
            }
        } else if (showCreateSheet) {
            AppBottomSheet(
                onDismissRequest = { showCreateSheet = false },
                title = stringResource(Res.string.post_sheet_title),
            ) {
                if (features.feed) {
                    // First slot: asking IS the community's primary creative act (Ask the Mahaleh).
                    CreateActionRow(
                        iconName = "forum",
                        label = stringResource(Res.string.post_action_ask),
                        onClick = {
                            showCreateSheet = false
                            FeedDeepLinks.requestAsk()
                        },
                    )
                }
                CreateActionRow(
                    iconName = "add_business",
                    label = stringResource(Res.string.post_action_business),
                    onClick = {
                        showCreateSheet = false
                        onAddBusiness()
                    },
                )
                if (features.feed) {
                    CreateActionRow(
                        iconName = "dynamic_feed",
                        label = stringResource(Res.string.post_action_feed),
                        onClick = {
                            showCreateSheet = false
                            selected = Tabs.FEED
                        },
                    )
                }
                if (features.marketplace) {
                    CreateActionRow(
                        iconName = "sell",
                        label = stringResource(Res.string.post_action_market),
                        onClick = {
                            showCreateSheet = false
                            // Land on Market with the sell composer already open — the tab has no
                            // create button of its own (the global Post FAB owns creation).
                            MarketplaceIntents.requestSell()
                            selected = Tabs.MARKET
                        },
                    )
                }
            }
        }

        // One-time owner welcome: the first time this account owns a listing (claim approved or listing
        // created), say so and offer the dashboard tour. Existing owners see it once after updating.
        val ownerRepository = koinInject<diana.soleil.design.iraniancanadienbazzar.core.data.OwnerRepository>()
        val ownedResult by remember { ownerRepository.observeOwnedBusinesses() }
            .collectAsState(initial = null)
        val firstOwned = (ownedResult as? diana.soleil.design.iraniancanadienbazzar.core.common.DataResult.Success)
            ?.data?.firstOrNull()
        var ownerWelcomeDismissed by remember { mutableStateOf(preferences.ownerWelcomeShown) }
        if (firstOwned != null && !ownerWelcomeDismissed) {
            diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet(
                onDismissRequest = {
                    preferences.ownerWelcomeShown = true
                    ownerWelcomeDismissed = true
                },
                title = stringResource(Res.string.owner_welcome_title, firstOwned.name),
            ) {
                androidx.compose.foundation.layout.Column(
                    modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.lg),
                    verticalArrangement = androidx.compose.foundation.layout.Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    Text(
                        text = stringResource(Res.string.owner_welcome_body),
                        style = AppTheme.typography.bodyMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                    diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton(
                        text = stringResource(Res.string.owner_welcome_tour),
                        onClick = {
                            preferences.ownerWelcomeShown = true
                            preferences.ownerTourRequested = true
                            ownerWelcomeDismissed = true
                            onOpenDashboard()
                        },
                        leadingIcon = "storefront",
                        modifier = Modifier.fillMaxWidth(),
                    )
                    diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton(
                        text = stringResource(Res.string.owner_welcome_later),
                        onClick = {
                            preferences.ownerWelcomeShown = true
                            ownerWelcomeDismissed = true
                        },
                        variant = diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant.Text,
                        modifier = Modifier.fillMaxWidth(),
                    )
                }
            }
        }

        // Spotlight feature tour — last child of the BoxWithConstraints so it layers over the whole
        // scaffold (bars + FAB included). Steps for flag-hidden tabs drop themselves (no anchor).
        FeatureTourOverlay(
            state = tour,
            steps = listOf(
                TourStep(Tabs.HOME, stringResource(Res.string.tour_home_title), stringResource(Res.string.tour_home_body)),
                TourStep(Tabs.FEED, stringResource(Res.string.tour_feed_title), stringResource(Res.string.tour_feed_body)),
                TourStep(Tabs.MARKET, stringResource(Res.string.tour_market_title), stringResource(Res.string.tour_market_body)),
                TourStep(Tabs.MESSAGES, stringResource(Res.string.tour_messages_title), stringResource(Res.string.tour_messages_body)),
                TourStep(TOUR_KEY_POST, stringResource(Res.string.tour_post_title), stringResource(Res.string.tour_post_body)),
                TourStep(Tabs.PROFILE, stringResource(Res.string.tour_profile_title), stringResource(Res.string.tour_profile_body)),
            ),
            nextLabel = stringResource(Res.string.tour_next),
            doneLabel = stringResource(Res.string.tour_done),
            skipLabel = stringResource(Res.string.tour_skip),
            onFinished = { preferences.featureTourComplete = true },
        )
    }
}

/** One tappable action in the create ("Post") sheet: leading icon + localized label. */
@Composable
private fun CreateActionRow(
    iconName: String,
    label: String,
    onClick: () -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(vertical = AppTheme.spacing.md, horizontal = AppTheme.spacing.lg),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        AppIcon(name = iconName, tint = AppTheme.colors.primary)
        Text(
            text = label,
            style = AppTheme.typography.bodyLg,
            color = AppTheme.colors.onSurface,
            modifier = Modifier.padding(start = AppTheme.spacing.md),
        )
    }
}
